import React, { useState } from 'react';
import { IconContext } from 'react-icons';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import UnifiedStarBackground from '../components/UnifiedStarBackground';
import ThankYouPopup from '../components/ThankYouPopup';
import { supabase } from '../config/supabaseClient';
import '../styles/Contact.css';

const Contact: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      // Insert message into Supabase
      const { error: supabaseError } = await supabase
        .from('messages')
        .insert([
          {
            name: formData.name,
            email: formData.email,
            message: `${formData.subject}\n\n${formData.message}`
          }
        ]);

      if (supabaseError) {
        throw supabaseError;
      }

      // Show thank you popup
      setIsPopupOpen(true);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (err) {
      console.error('Error submitting message:', err);
      setError(err instanceof Error ? err.message : 'Failed to send message');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <IconContext.Provider value={{ className: 'react-icons' }}>
      <div className="contact">
        <UnifiedStarBackground variant="primary" />
        <div className="contact-hero">
          <div className="container">
            <h1>Contact Us</h1>
            <p>Get in touch with us for any queries or suggestions</p>
          </div>
        </div>

        <div className="container section">
          <div className="contact-grid">
            <div className="contact-info">
              <div className="info-card card">
                <h3><FaMapMarkerAlt /> Address</h3>
                
                <p>SGGS Nanded </p>
                <p>India</p>
              </div>

              <div className="info-card card">
                <h3><FaPhone /> Phone</h3>
                <p>+9322702740</p>
                
              </div>

              <div className="info-card card">
                <h3><FaEnvelope /> Email</h3>
                <p>2023bcs006@sggs.ac.in</p>
                
              </div>
            </div>

            <div className="contact-form card">
              <h2>Send us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                    autoComplete="name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    required
                    autoComplete="email"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="What is your message about?"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                    required
                  />
                </div>

                {error && <div className="error-message">{error}</div>}
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ThankYouPopup 
        isOpen={isPopupOpen}
        onClose={handlePopupClose}
        message="Thank you for contacting us! We'll get back to you soon."
      />
    </IconContext.Provider>
  );
};

export default Contact;